class AwBacklink extends HTMLAnchorElement {
    goBackCount = 1;
    constructor(){
        super();
    }

    connectedCallback() {
        window.addEventListener('popstate', () => {
            //we store how often we navigate internally, in order to go back to the right page
            //i.e. we want to ignore page#id-1 
            this.goBackCount++;
        });
        this.href = document.referrer;
        this.addEventListener('click', (event) => {
            //we simulate the browser back button, meaning that
            // - we go back to the previous page 
            // - we don't put the current page back on the history stack
            //Meaning that if the user went page A -> B -> C
            //And presses this link on page "C" he goes back to B
            //And if he uses the browser back function on "B" he goes to "A"
            //If we would put it on the stack he would go from "B" back to "C"
            history.go(-this.goBackCount);
            event.preventDefault();
        })
    }
}

customElements.define("aw-back-link", AwBacklink, {extends: "a"});
